import { useMemo } from "react";
import { Service as BaseService, useService as useBaseService } from "./Base";
import { LoginPayload } from "../context/Auth";

interface ExchangeGoogleCodeParams {
    code: string;
    userID?: string;
}

export class Service {
    base: BaseService;
    route: string;

    constructor(service: BaseService, route: string) {
        this.base = service;
        this.route = route;
    }

    async exchangeGoogleCode(data: ExchangeGoogleCodeParams) {
        return await this.base.fetchAPI<LoginPayload>(
            `${this.route}/exchange`,
            {
                method: "POST",
                body: data,
            },
        );
    }
}

export const useService = () => {
    const base = useBaseService();

    return useMemo(() => {
        return new Service(base, "/google");
    }, [base]);
};
